<template>
  <div class="header">
    <div class="content">
      <div class="top" v-if="showTCPrice">
        {{ i18n.TCPrice }}: <span>{{ tcprice }} {{ i18n.dollar }} ({{ tc_float }})</span>
      </div>
      <div class="bottom">
        <router-link to="/" class="left">
          <img src="/logo.png" alt="" />
          <div class="shard-selector" @mouseout="mouseout">
            <div class="li" @mouseover="showPopup = true">
              {{ currentShardName }}
              <i class="el-icon-arrow-down"></i>
            </div>
            <div class="popup" v-show="showPopup" @mouseover="mouseover1">
              <div class="sjx"></div>
              <div class="popList">
                <div class="list" :class="{ listactive: Sliceno === item.sliceno }" v-for="item in SlicenoList" :key="item.sliceno" @click="changeSliceno(item)">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </router-link>
        <div class="middle">
          <div class="li" :class="{ liactive: isactive == item.id }" v-for="(item, index) in pageList" :key="index" @click="changePage(item)" @mouseover="mouseover(item)">
            {{ item.name }}
          </div>
        </div>
        <div class="right">
          <div class="language-selector" ref="languageSelector">
            <div class="current-language" @click="toggleDropdown">
              <span>{{ currentLanguageName }}</span>
              <i class="el-icon-arrow-down"></i>
            </div>
            <div class="popup" v-show="showLang">
              <div class="popList">
                <div class="list" @click="changeLanguage('en-US')">English</div>
                <div class="list" @click="changeLanguage('zh-CN')">中文</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from '../config'
export default {
  name: 'DczxxNave',
  data() {
    return {
      showTCPrice: config.showTCPrice,
      pageList: [],
      isactive: 1,
      showPopup: false,
      showLang: false,
      SlicenoList: [],
      Sliceno: null,
      tcprice: '',
      tc_float: '',
      currentShardName: '',
    }
  },
  computed: {
    i18n() {
      return this.$t('nav')
    },
    currentLanguageName() {
      return this.$i18n.locale === 'en-US' ? 'English' : '中文'
    },
  },
  watch: {
    $route(to, from) {
      if (to.path == '/') {
        sessionStorage.setItem('key', 1)
        this.isactive = 1
      } else if (to.path == '/TokenList') {
        sessionStorage.setItem('key', 2)
        this.isactive = 2
      } else if (to.path == '/ShardInformation') {
        sessionStorage.setItem('key', 3)
        this.isactive = 3
      } else if (to.path == '/DevelopmentDocuments') {
        sessionStorage.setItem('key', 5)
        this.isactive = 5
      }
    },
  },
  created() {
    this.$bus.$on('brotherEvent', (res) => {
      this.isactive = res
    })
    this.$i18n.locale = localStorage.getItem('VoidChainLang')
    if (this.$i18n.locale === 'zh-CN') {
      this.pageList = [
        {
          id: 1,
          name: '主页',
          path: '/',
        },
        {
          id: 2,
          name: '代币列表',
          path: '/TokenList',
        },
        {
          id: 5,
          name: '开发文档',
          path: '/DevelopmentDocuments',
        },
      ]
    } else if (this.$i18n.locale === 'en-US') {
      this.pageList = [
        {
          id: 1,
          name: 'Homepage',
          path: '/',
        },
        {
          id: 2,
          name: 'Token List',
          path: '/TokenList',
        },
        {
          id: 5,
          name: 'Development documents',
          path: '/DevelopmentDocuments',
        },
      ]
    }
  },
  mounted() {
    this.isactive = sessionStorage.getItem('key')
    this.Sliceno = Number(sessionStorage.getItem('Sliceno'))
    this.getsysSliceno()
    this.gettcInfo()
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    toggleDropdown() {
      this.showLang = !this.showLang
    },
    handleClickOutside(event) {
      if (this.$refs.languageSelector && !this.$refs.languageSelector.contains(event.target)) {
        this.showLang = false
      }
    },
    translateShardName(name) {
      if (this.$i18n.locale !== 'en-US') {
        return name
      }
      switch (name) {
        case '主分片':
          return 'Main Meta Space'
        case '百万分片一':
          return 'Million Meta Space 1'
        default:
          return name
      }
    },
    getsysSliceno() {
      this.$axios.post('/index/web/sysSliceno', {})
        .then((res) => {
          this.SlicenoList = res.data.data.map((item) => ({
            ...item,
            name: this.translateShardName(item.name),
          }))
          if (this.Sliceno == 0) {
            this.currentShardName = this.SlicenoList[0].name
          } else {
            const currentShard = this.SlicenoList.find((item) => item.sliceno === this.Sliceno)
            if (currentShard) {
              this.currentShardName = currentShard.name
            }
          }
        })
        .catch((error) => {
          // Error is already handled by interceptor
          console.error('Failed to fetch meta space list:', error)
          // Set default values to prevent UI issues
          this.SlicenoList = []
          this.currentShardName = 'Main Meta Space'
        })
    },
    gettcInfo() {
      this.$axios.post('/index/web/tcInfo', {})
        .then((res) => {
          this.tcprice = res.data.data.tcprice
          this.tc_float = res.data.data.tc_float
        })
        .catch((error) => {
          // Error is already handled by interceptor
          console.error('Failed to fetch TC info:', error)
          // Set default values
          this.tcprice = '0.00'
          this.tc_float = '0.00'
        })
    },
    changeSliceno(item) {
      sessionStorage.setItem('Sliceno', item.sliceno)
      this.Sliceno = Number(sessionStorage.getItem('Sliceno'))
      this.currentShardName = item.name
      this.showPopup = false
      if (this.$route.path === '/PartitionSelection' || this.$route.path === '/ShardInformation') {
        window.location.reload()
      }
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang
      this.showLang = false
      localStorage.setItem('VoidChainLang', lang)
      if (this.$i18n.locale === 'zh-CN') {
        this.pageList = [
          {
            id: 1,
            name: '主页',
            path: '/',
          },
          {
            id: 2,
            name: '代币列表',
            path: '/TokenList',
          },
          {
            id: 5,
            name: '开发文档',
            path: '/DevelopmentDocuments',
          },
        ]
      } else if (this.$i18n.locale === 'en-US') {
        this.pageList = [
          {
            id: 1,
            name: 'Homepage',
            path: '/',
          },
          {
            id: 2,
            name: 'Token List',
            path: '/TokenList',
          },
          {
            id: 5,
            name: 'Development documents',
            path: '/DevelopmentDocuments',
          },
        ]
      }
      this.getsysSliceno()
    },
    changePage(item) {
      if (item.path === this.$route.path) {
        console.log('已在当前页面', this.$route.path)
      } else {
        switch (item.id) {
          case 1:
            this.isactive = item.id
            sessionStorage.setItem('key', this.isactive)
            this.$router.push(item.path)
            break
          case 2:
            this.isactive = item.id
            sessionStorage.setItem('key', this.isactive)
            this.$router.push(item.path)
            break
          case 3:
            return false
            break
          case 5:
            this.isactive = item.id
            sessionStorage.setItem('key', this.isactive)
            this.$router.push(item.path)
            break

          default:
            break
        }
      }
    },
    mouseover(item) {
      if (item.id === 3) {
        this.showPopup = false
      } else {
        this.showPopup = false
      }
    },
    mouseover1() {
      this.showPopup = true
    },
    mouseout() {
      this.showPopup = false
    },
  },
}
</script>
<style lang="scss" scoped>
.header {
  background: #fbfcfd;
  .content {
    width: 100%;
    padding: 13px 219px 12px 208px;
    box-sizing: border-box;
    .top {
      font-family: 'HarmonyOS Sans';
      font-size: 9px;
      font-weight: 400;
      color: #21325b;
      margin-bottom: 22px;
      span {
        color: #006aff;
      }
    }
    .bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        height: 100%;
        display: flex;
        align-items: center;
        position: relative;
        text-decoration: none;
        .shard-selector {
          position: relative;
          margin-left: 20px;
          .li {
            height: 26px;
            color: #212333;
            font-family: '思源黑体';
            font-size: 12px;
            font-weight: 400;
            text-align: center;
            margin-right: 10px;
            line-height: 26px;
            padding: 0 8px;
            cursor: pointer;
          }
          .popup {
            position: absolute;
            top: 18px;
            left: -10px;
            z-index: 100000;
            background: #fff;
            .sjx {
              width: 100%;
              height: 20px;
            }
            .popList {
              border-radius: 0px 0px 6px 6px;
              background: #fff;
              padding: 7px 8px;
              box-sizing: border-box;
              box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.25);
              .list {
                color: rgb(50, 50, 51);
                font-family: 'HarmonyOS Sans';
                font-size: 10px;
                font-weight: 400;
                text-align: center;
                border-bottom: 1px solid #afb4be;
                margin-bottom: 8px;
                padding: 0px 0px 8px;
                cursor: pointer;
                white-space: nowrap;
              }
              .list:last-child {
                padding-bottom: 0;
                margin-bottom: 0;
                border: 0;
              }
              .listactive {
                color: #006aff;
              }
            }
          }
        }
        img {
          width: 120px;
          height: 26px;
          margin-right: 6px;
        }
      }
      .middle {
        height: 26px;
        display: flex;
        align-items: center;
        position: relative;
        .li {
          height: 26px;
          color: #212333;
          font-family: '思源黑体';
          font-size: 12px;
          font-weight: 400;
          text-align: center;
          margin-right: 10px;
          line-height: 26px;
          padding: 0 8px;
          cursor: pointer;
        }
        .liactive {
          color: #006aff;
        }
        .popup {
          position: absolute;
          top: 18px;
          // left: calc(50% - 50px);
          z-index: 100000;
          background: #fff;
          .sjx {
            width: 100%;
            height: 20px;
          }
          .popList {
            border-radius: 0px 0px 6px 6px;
            background: #fff;
            padding: 7px 8px;
            box-sizing: border-box;
            box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.25);
            .list {
              color: rgb(50, 50, 51);
              font-family: 'HarmonyOS Sans';
              font-size: 10px;
              font-weight: 400;
              text-align: center;
              border-bottom: 1px solid #afb4be;
              margin-bottom: 8px;
              padding: 0px 0px 8px;
              cursor: pointer;
            }
            .list:last-child {
              padding-bottom: 0;
              margin-bottom: 0;
              border: 0;
            }
            .listactive {
              color: #006aff;
            }
          }
        }
        @media (min-width: 900px) and (max-width: 1920px) {
          .popup {
            left: calc(50% - 50px);
          }
        }
        @media (max-width: 899px) {
          .popup {
            left: calc(50% - 80px);
          }
        }
      }
      .right {
        display: flex;
        align-items: center;
        .language-selector {
          position: relative;
          cursor: pointer;
          .current-language {
            display: flex;
            align-items: center;
            font-family: 'HarmonyOS Sans';
            font-size: 14px;
            color: #21325b;
            i {
              margin-left: 6px;
              font-size: 12px;
            }
          }
          .popup {
            position: absolute;
            top: 25px;
            right: 0;
            z-index: 100000;
            background-color: #fff;
            border-radius: 6px;
            box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.1);
            overflow: hidden;
            .popList {
              .list {
                padding: 10px 20px;
                font-family: 'HarmonyOS Sans';
                font-size: 14px;
                color: #21325b;
                white-space: nowrap;
                text-align: center;
                &:hover {
                  background-color: #f0f2f5;
                }
              }
            }
          }
        }
        .img {
          display: flex;
          align-items: center;
          cursor: pointer;
          position: relative;
          .lang {
            width: 19px;
            height: 19px;
            display: block;
            margin-right: 8.41px;
          }
          .jiantou {
            width: 13px;
            height: 7px;
            display: block;
          }
          .popup {
            position: absolute;
            top: 30px;
            left: 50%;
            z-index: 100000;
            .sjx {
              width: 0px;
              height: 0px;
              border-top: 6px solid rgba(212, 55, 141, 0);
              border-bottom: 6px solid #fff;
              border-left: 6px solid rgba(184, 50, 27, 0);
              border-right: 6px solid rgba(184, 50, 27, 0);
              margin-left: 8px;
            }
            .popList {
              width: 72px;
              border-radius: 8px;
              background: #fff;
              padding: 8px 9px;
              box-sizing: border-box;
              box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.25);
              .list {
                color: rgb(50, 50, 51);
                font-family: 'HarmonyOS Sans';
                font-size: 10px;
                font-weight: 400;
                text-align: center;
                padding-bottom: 8px;
                border-bottom: 1px solid #afb4be;
                margin-bottom: 8px;
                cursor: pointer;
              }
              .list:last-child {
                padding-bottom: 0;
                margin-bottom: 0;
                border: 0;
              }
              .listactive {
                color: #006aff;
              }
            }
          }
        }
      }
    }
  }
}
</style>
